import DrawerButton from "components/form/DrawerButton";
import Error from "components/form/Error";
import InputArea from "components/form/InputArea";
import LabelArea from "components/form/LabelArea";
import Title from "components/form/Title";
import useBookingSubmit from "hooks/useBookingSubmit";
import React, { useState, useEffect } from "react";
import Scrollbars from "react-custom-scrollbars-2";
import InputAreaDate from "components/form/InputAreaDate";
import BookingSelectSingleCityOnly from "components/form/BookingDrawerSelectSingleCityOnly";
import SelectSingleCityOnly from "components/form/SelectSingleCityOnly";
import SelectTripType from "components/form/SelectTripType";
import QuillEditor from "components/form/QuillEditor";
import SelectVia from "components/form/SelectVia";
import SelectAgent from "components/form/SelectAgent";
import InputMobileWoCode from "components/form/InputMobileWoCode";
import InputAreaPrice from "components/form/InputAreaPrice";
import SelectVehicleModel from "components/form/SelectVehicleModel";
import SelectVehicleCat from "components/form/SelectVehicleCat";
import { Select } from "@windmill/react-ui";
import SelectTime from "components/form/SelectTime";
import SelectSingleAirportId from "components/form/SelectSingleAirportId";
import RadioButton from "components/form/RadioButton";
import InputName from "components/form/InputName";
import SelectOneWayPackage from "components/form/SelectOneWayPackage";
import SelectOnewayVehicle from "components/form/SelectOnewayVehicle";
import CityServices from "services/CityServices";

const BookingsDrawerCity = ({ id }) => {
  const [childCount, setChildCount] = useState(0);
  const {
    trigger,
    watch,
    setValue,
    register,
    handleSubmit,
    onSubmit,
    errors,
    selectedStartCity,
    setSelectedStartCity,
    setSelectedSeat,
    selectedSeat,
    selectedEndCity,
    setSelectedEndCity,
    startDate,
    setStartDate,
    endDate,
    bookingDate,
    setBookingDate,
    setSelectedTripType,
    selectedTripType,
    setItinerary,
    itinerary,
    setSpecialNote,
    specialNote,
    vehicleNote,
    setVehicleNote,
    arrivalVia,
    setArrivalVia,
    departureVia,
    setDepartureVia,
    setSelectedStartCityName,
    setSelectedEndCityName,
    selectedEndCityName,
    selectedStartCityName,
    days,
    setDays,
    agentId,
    setAgentId,
    vehicleModel,
    vehicleType,
    setVehicleModel,
    setVehicleType,
    pickupTime,
    setPickupTime,
    setHourRentaltype,
    hourrentalType,
    isOnline,
    myData,
    loading,
    title,
    setTitle,
    selectedMultiValue,
    handleChangeMultiTrip,

    setAdultCount,
    adultCount,
    selectedOneWayPackage,
    setSelectedOneWayPackage,
    selectedOneWayPackageName,
    setSelectedOneWayPackageName,
  } = useBookingSubmit(id);

 const [cities, setSingleCity] = useState([]);

    useEffect(() => {
      let isMounted = true; // Add this variable to track the component's mounting state
  
      async function fetchCity() {
        try {
          const response = await CityServices.getAllCity();
          const transformedData = response.data.map((item) => ({
            value: String(item.id_city),
            label: item.name,
          }));
  
          // Check if the component is still mounted before updating the state
          if (isMounted) {
            setSingleCity(transformedData);
          }
        } catch (error) {
          console.error("Error fetching cities:", error);
        }
      }
  
      fetchCity();
  
      // Cleanup function to set isMounted to false when the component is unmounted
      return () => {
        isMounted = false;
      };
    }, []);

  const handleDaysChange = (e) => {
    const value = parseInt(e.target.value, 10);
    setDays(value || 0);
  };

  useEffect(() => {
    if (watch(`day_1_start_date`)) {
      for (let i = 1; i < days; i++) {
        const currentDayDate = new Date(watch(`day_${i}_start_date`));
        currentDayDate.setDate(currentDayDate.getDate() + 1);
        setValue(`day_${i + 1}_start_date`, currentDayDate);
      }
    }
    //eslint-disable-next-line
  }, [watch(`day_1_start_date`), setValue, days]);
  useEffect(() => {
    const firstDayStartDate = watch(`day_1_start_date`); // Extracting watch value

    if (firstDayStartDate) {
      for (let i = 1; i < days; i++) {
        const currentDayDate = new Date(watch(`day_${i}_start_date`));
        currentDayDate.setDate(currentDayDate.getDate() + 1);
        setValue(`day_${i + 1}_start_date`, currentDayDate);
      }
    }
  }, [days, setValue, watch]); // Include 'watch' and 'setValue' as dependencies

  // useEffect(() => {
  //   if (selectedStartCityName) {
  //     setValue(`day_1_startcity`, selectedStartCityName);
  //   }

  //   if (selectedEndCityName) {
  //     setValue(`day_${days}_endcity`, selectedEndCityName);
  //   }

  //   for (let i = 1; i < days - 1; i++) {
  //     const previousEndCity = watch(`day_${i}_endcity`);
  //     if (previousEndCity) {
  //       setValue(`day_${i + 1}_startcity`, previousEndCity);
  //     }
  //   }
  // }, [selectedStartCityName, selectedEndCityName, days, watch]);
  useEffect(() => {
    if (selectedStartCityName) {
      setValue(`day_1_startcity`, selectedStartCityName);
    }

    if (selectedEndCityName) {
      setValue(`day_${days}_endcity`, selectedEndCityName);
    }

    for (let i = 1; i < days - 1; i++) {
      const previousEndCity = watch(`day_${i}_endcity`);
      if (previousEndCity) {
        setValue(`day_${i + 1}_startcity`, previousEndCity);
      }
    }
  }, [selectedStartCityName, selectedEndCityName, days, watch, setValue]);

  const handleAdultChange = (value) => {
    const newAdultCount = parseInt(value, 10);
    const remainingSeats = selectedSeat - newAdultCount;
    if (remainingSeats >= 0) {
      setAdultCount(newAdultCount);

      if (childCount > remainingSeats) {
        setChildCount(remainingSeats);
      }
    }
  };

  const handleChildChange = (value) => {
    setChildCount(parseInt(value, 10));
  };

  const adultOptions = Array.from({ length: selectedSeat }, (_, i) => i + 1);
  const childOptions = Array.from(
    { length: selectedSeat - adultCount + 1 },
    (_, i) => i,
  );

  function formatDate(dateString) {
    if (!dateString) return ""; // Handle empty or undefined input
    const date = new Date(dateString);
    if (isNaN(date)) return ""; // Handle invalid dates
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = date.getFullYear();
    return `${day}-${month}-${year}`;
  }

  useEffect(() => {
    if (myData?.no_of_adult) {
      setAdultCount(Number(myData?.no_of_adult));
      setChildCount(Number(myData?.no_of_kids));
    }
  }, [myData]);

  // cannot edit if:
  // - booking is Online (agent-portal booking) — price is never editable here, or
  // - the trip's allotment has been marked Completed — locked for everyone.
  // Staying editable up to and through the trip's own dates is intentional —
  // the trip isn't actually over just because its end date has passed; only
  // the explicit Completed marking means that.
  const cantEditSellingPrice = isOnline || myData?.trip_completed === "1";

  // For multi-day trips (Outstation / Holiday Package), Day 1's Start Date
  // can be pushed further into the future but never dragged back down to
  // today — the vehicle allotment for this trip may already be scheduled
  // against the original date, so today itself is excluded from the picker
  // (not just past dates), leaving only strictly-future dates selectable.
  // Airport Pickup/Drop and Hourly Rental are single-day bookings and don't
  // need this — their own Trip Date picker already allows today.
  const minMultiDayStartDate = new Date();
  minMultiDayStartDate.setDate(minMultiDayStartDate.getDate() + 1);
  minMultiDayStartDate.setHours(0, 0, 0, 0);

  // Once a trip has already started, every field is locked except Selling
  // Price, Special Note and Vehicle Note — mirrors the same rule enforced
  // server-side in clientModel.js's updateClient (which only applies those
  // three fields once the trip has started, ignoring the rest of the payload).
  const tripStartedLock = !!myData?.trip_already_started;

  return (
    <>
      <div className="w-full relative p-6 border-b border-gray-100 bg-gray-50 dark:border-gray-700 dark:bg-gray-800 dark:text-gray-300">
        {id ? (
          <Title title={"Edit Booking"} />
        ) : (
          <Title title={"Add Booking"} />
        )}
      </div>

      <Scrollbars className="w-full md:w-7/12 lg:w-8/12 xl:w-8/12 relative dark:bg-gray-700 dark:text-gray-200">
        <form onSubmit={handleSubmit(onSubmit)}>
          <div className="px-6 pt-8 scrollbar-hide flex-grow w-full h-full max-h-full pb-40 md:pb-32 lg:pb-32 xl:pb-32">
            {/* Online (agent-portal) bookings are fully read-only here — every
                            field, including date and city, is locked; edits for those must
                            go through the agent-side edit flow instead. */}
            <fieldset disabled={isOnline} className="contents">
              <div className="grid grid-cols-6 gap-3 md:gap-5 xl:gap-6 lg:gap-6 mb-6">
                <div className="col-span-6">
                  <LabelArea label={"Type of Service"} required />

                  <SelectTripType
                    readOnly={!!id}
                    required={!id}
                    register={register}
                    defaultValue={selectedTripType}
                    onChange={(e) => setSelectedTripType(e.target.value)}
                    name="package_type"
                    label="Type of Service"
                  />
                  <Error errorName={errors.package_type} />
                </div>
              </div>

              {selectedTripType ? (
                <>
                  <div className="grid grid-cols-12 gap-3 md:gap-5 xl:gap-6 lg:gap-6 mb-6">
                    {/* Once a trip has started, everything is locked except
                                        Selling Price, Client Name, Contact Number, Itinerary
                                        Details, Special Note and Vehicle Note — those fields
                                        are deliberately outside the tripStartedLock fieldsets. */}
                    <fieldset disabled={tripStartedLock} className="contents">
                      <div className="col-span-2">
                        <LabelArea label={"Title"} required />
                        <Select
                          className="border h-10 text-sm focus:outline-none block w-full bg-white-100 dark:bg-white border-transparent focus:bg-white"
                          {...register("title", {
                            required: !title ? "title is required!" : false,
                          })}
                          label="title"
                          name="title"
                          defaultValue={title}
                          onChange={(e) => setTitle(e.target.value)}
                          onBlur={() => trigger("title")}
                        >
                          <option value={"Mr."}>Mr.</option>
                          <option value={"Mrs."}>Mrs.</option>
                          <option value={"Miss."}>Miss.</option>
                          <option value={"Ms."}>Ms.</option>
                        </Select>

                        <Error errorName={errors.title} />
                      </div>
                    </fieldset>

                    {/* Client Name stays editable even once the trip has
                                            started — same reasoning as Selling Price/notes below:
                                            intentionally outside the tripStartedLock fieldset. */}
                    <div className="col-span-5">
                      <LabelArea label={"Client Name "} required />
                      <InputName
                        trigger={trigger}
                        register={register}
                        label="Client Name "
                        name="client_name"
                        type="text"
                        placeholder={"Client Name "}
                        // pattern={/^[a-zA-Z\s]+$/}
                      />
                      <Error errorName={errors.client_name} />
                    </div>

                    <fieldset disabled={tripStartedLock} className="contents">
                      {/* Agent Name */}
                      {isOnline ? (
                        <div className="col-span-5">
                          <LabelArea label={"Agent Name"} required />
                          <input
                            type="text"
                            disabled
                            value={myData?.agentname || ""}
                            readOnly
                            className="border h-10 text-sm focus:outline-none block w-full bg-white-100 dark:bg-white border-transparent focus:bg-white"
                          />
                        </div>
                      ) : (
                        <div className="col-span-5">
                          <LabelArea label={"Agent Name"} required />
                          <SelectAgent
                            name="agent_id"
                            label="Agent Name"
                            register={register}
                            value={agentId}
                            onChange={(e) => setAgentId(e.target.value)}
                          />

                          <Error errorName={errors.agent_id} />
                        </div>
                      )}

                      {isOnline ? (
                        <div className="col-span-4">
                          <LabelArea label={"Agent Ref No"} required />
                          <input
                            type="text"
                            disabled
                            value={myData?.agentref || ""}
                            readOnly
                            className="border h-10 text-sm focus:outline-none block w-full bg-white-100 dark:bg-white border-transparent focus:bg-white"
                          />
                        </div>
                      ) : (
                        <div className="col-span-4">
                          <LabelArea label={"Agent Ref No"} required />
                          <InputArea
                            trigger={trigger}
                            register={register}
                            label="Agent Ref No"
                            name="agentref"
                            type="text"
                            placeholder={"Agent Ref No"}
                          />
                          <Error errorName={errors.agentref} />
                        </div>
                      )}
                    </fieldset>

                    {/* Contact Number stays editable even once the trip has
                                            started — same as Client Name above. */}
                    <div className="col-span-4">
                      <LabelArea label={"Contact Number"} required />
                      <InputMobileWoCode
                        trigger={trigger}
                        register={register}
                        label="Contact Number"
                        name="contact_no"
                        type="text"
                        placeholder={"Contact Number"}
                        minLength={10}
                        maxLength={10}
                        pattern={/^\d{10}$/}
                      />
                      <Error errorName={errors.contact_no} />
                    </div>

                    <fieldset disabled={tripStartedLock} className="contents">
                      {/* Alternate Contact Number */}
                      <div className="col-span-4">
                        <LabelArea
                          label={"Alternate Contact Number (Optional)"}
                        />
                        <InputMobileWoCode
                          trigger={trigger}
                          register={register}
                          required={false}
                          label="Alternate Contact Number"
                          name="al_contact_no"
                          type="text"
                          placeholder={"Alternate Contact Number"}
                          minLength={10}
                          maxLength={10}
                          pattern={/^\d{10}$/}
                        />
                        <Error errorName={errors.al_contact_no} />
                      </div>

                      {/* Start City */}
                      <div className="col-span-4">
                        {selectedTripType !== "Airport Pickup" &&
                        selectedTripType !== "Oneway" ? (
                          <>
                            <LabelArea label={"Start City"} required />
                            <SelectSingleCityOnly
                              cities={cities}
                              register={register}
                              label="Start City"
                              name="startcity"
                              type="text"
                              placeholder={"--Choose--"}
                              selectedCity={selectedStartCity}
                              handleCityChange={setSelectedStartCity}
                              handleCityChangeName={(e) =>
                                setSelectedStartCityName(e)
                              }
                              readonly={tripStartedLock || isOnline}
                            />
                            <Error errorName={errors.startcity} />
                          </>
                        ) : null}

                        {selectedTripType === "Airport Pickup" ? (
                          <>
                            <LabelArea label={"Airport Name"} required />
                            <SelectSingleAirportId
                              register={register}
                              label="Name of the Airport"
                              name="name_of_aiport"
                              type="text"
                              placeholder={"--Choose--"}
                              selectedCity={selectedStartCity}
                              handleCityChange={setSelectedStartCity}
                              handleCityChangeName={setSelectedStartCityName}
                              readonly={tripStartedLock || isOnline}
                            />
                            <Error errorName={errors.name_of_aiport} />
                          </>
                        ) : null}

                        {selectedTripType === "Oneway" ? (
                          <>
                            <LabelArea label={"One Way Package"} required />
                            <SelectOneWayPackage
                              register={register}
                              name="onewaypackage"
                              label="One Way Package"
                              selectedPackage={selectedOneWayPackage}
                              handlePackageChange={(pkg) => {
                                setSelectedOneWayPackage(pkg);
                              }}
                              handlePackageLabelChange={
                                setSelectedOneWayPackageName
                              }
                              id={id}
                              readonly={tripStartedLock || isOnline}
                            />
                            <Error errorName={errors.onewaypackage} />
                          </>
                        ) : null}
                      </div>

                      {/* End City */}
                      {selectedTripType !== "Hour Rental" &&
                      selectedTripType !== "Airport Drop" &&
                      selectedTripType !== "Oneway" ? (
                        <div className="col-span-4">
                          <LabelArea label={"End City"} required />
                          <SelectSingleCityOnly
                            cities={cities}
                            register={register}
                            label="End City"
                            name="endcity"
                            type="text"
                            placeholder={"--Choose--"}
                            selectedCity={selectedEndCity}
                            handleCityChange={setSelectedEndCity}
                            handleCityChangeName={(e) =>
                              setSelectedEndCityName(e)
                            }
                            readonly={tripStartedLock || isOnline}
                          />
                          <Error errorName={errors.endcity} />
                        </div>
                      ) : null}

                      {selectedTripType === "Airport Drop" ? (
                        <div className="col-span-4">
                          <LabelArea label={"Airport Name"} required />
                          <SelectSingleAirportId
                            register={register}
                            label="Name of the Airport"
                            name="name_of_aiport"
                            type="text"
                            placeholder={"--Choose--"}
                            selectedCity={selectedEndCity}
                            handleCityChange={setSelectedEndCity}
                            handleCityChangeName={setSelectedEndCityName}
                            readonly={tripStartedLock || isOnline}
                          />
                          <Error errorName={errors.name_of_aiport} />
                        </div>
                      ) : null}

                      {selectedTripType !== "Airport Pickup" &&
                      selectedTripType !== "Airport Drop" &&
                      selectedTripType !== "Hour Rental" ? (
                        <>
                          {/* Arrival Via */}
                          <div className="col-span-4">
                            <LabelArea label={"Arrival Via (Optional)"} />
                            <SelectVia
                              title={"Arrival Via"}
                              register={register}
                              //    required={true}
                              defaultValue={arrivalVia}
                              onChange={(e) => setArrivalVia(e.target.value)}
                              name="arrival_via"
                              label="Arrival Via"
                            />
                            <Error errorName={errors.arrival_via} />
                          </div>

                          {/* Arrival Details */}
                          {arrivalVia ? (
                            <div className="col-span-4">
                              <LabelArea label={"Arrival Details (Optional)"} />
                              <InputArea
                                trigger={trigger}
                                register={register}
                                label="Arrival Details"
                                name="arrival_details"
                                type="text"
                                placeholder={`${arrivalVia} Details`}
                                required={false} // explicitly mark as optional
                                // pattern={/^[a-zA-Z\s]+$/} // optional: uncomment if you want pattern validation
                              />
                              <Error errorName={errors.arrival_details} />
                            </div>
                          ) : null}

                          {/* Departure Via */}
                          <div className="col-span-4">
                            <LabelArea label={"Departure Via (Optional)"} />
                            <SelectVia
                              required={false}
                              title={"Departure Via"}
                              register={register}
                              defaultValue={departureVia}
                              onChange={(e) => setDepartureVia(e.target.value)}
                              name="departure_via"
                              label="Departure Via"
                            />
                            <Error errorName={errors.departure_via} />
                          </div>

                          {/* Departure Details */}
                          {departureVia ? (
                            <div className="col-span-4">
                              <LabelArea
                                label={"Departure Details (Optional)"}
                              />
                              <InputArea
                                required={false}
                                trigger={trigger}
                                register={register}
                                label="Departure Details"
                                name="departure_details"
                                type="text"
                                placeholder={`${departureVia} details`}
                                // pattern={/^[a-zA-Z\s]+$/}
                              />
                              <Error errorName={errors.departure_details} />
                            </div>
                          ) : null}
                        </>
                      ) : null}

                      {selectedTripType === "Airport Pickup" ||
                      selectedTripType === "Airport Drop" ||
                      selectedTripType === "Hour Rental" ||
                      selectedTripType === "Oneway" ? (
                        <div className="col-span-4">
                          <LabelArea label="Trip Date" required />

                          <InputAreaDate
                            trigger={trigger}
                            register={register}
                            label="Trip Date"
                            name="start_date"
                            type="date"
                            value={startDate}
                            onChange={(event) => {
                              setStartDate(event);
                            }}
                            min={new Date()}
                            readOnly={tripStartedLock}
                          />

                          <Error errorName={errors.start_date} />
                        </div>
                      ) : null}

                      {selectedTripType === "Airport Pickup" ||
                      selectedTripType === "Airport Drop" ||
                      selectedTripType === "Hour Rental" ? (
                        <div className="col-span-4">
                          <LabelArea required label="Pick-Up Time" />
                          <SelectTime
                            register={register}
                            label="Pickup Time"
                            name={`pickup_time`}
                            value={pickupTime}
                            required={true}
                            onChangeFunction={(value) => setPickupTime(value)}
                            placeholder={"Pickup time"}
                            disabled={tripStartedLock}
                          />
                          <br />
                          <Error errorName={errors.pickup_time} />
                        </div>
                      ) : (
                        <>
                          <div className="col-span-4">
                            <LabelArea label="Pick-Up Time (Optional)" />
                            <SelectTime
                              register={register}
                              label="Pickup Time"
                              name={`pickup_time`}
                              value={pickupTime}
                              required={false}
                              onChangeFunction={(value) => setPickupTime(value)}
                              placeholder={"Pickup time"}
                              disabled={tripStartedLock}
                            />
                            <br />
                            <Error errorName={errors.pickup_time} />
                          </div>
                        </>
                      )}

                      {selectedTripType === "Hour Rental" ? (
                        <>
                          <div className="col-span-4">
                            <LabelArea label="Hour Rental Type" required />
                            <Select
                              className="border h-10 text-sm focus:outline-none block w-full bg-white-100 dark:bg-white border-transparent focus:bg-white"
                              {...register("hour_rental_type", {
                                required: !hourrentalType
                                  ? "Hour Rental Type is required!"
                                  : false,
                              })}
                              label="Hour Rental Type"
                              name="hour_rental_type"
                              defaultValue={hourrentalType}
                              onChange={(e) =>
                                setHourRentaltype(e.target.value)
                              }
                              onBlur={() => trigger("hour_rental_type")}
                            >
                              {/* <option value={2}>4h 40km</option>
                              <option value={3}>6h 60km</option> */}
                              <option value={4}>8h 80km</option>
                              <option value={5}>10h 100km</option>
                            </Select>

                            <Error errorName={errors.hour_rental_type} />
                          </div>
                        </>
                      ) : null}

                      {/* Vehicle Type */}
                      {selectedTripType !== "Oneway" ? (
                        <div className="col-span-4">
                          <LabelArea label={"Vehicle Type"} required />
                          <SelectVehicleCat
                            register={register}
                            label="Vehicle Type"
                            name="vehicle_type"
                            type="text"
                            defaultValue={vehicleType}
                            handleSeat={setSelectedSeat}
                            handleType={setVehicleType}
                            placeholder={"Vehicle Type"}
                          />
                          <Error errorName={errors.vehicle_type} />
                        </div>
                      ) : (
                        <div className="col-span-4">
                          <LabelArea label={"Vehicle Type"} required />
                          <SelectOnewayVehicle
                            register={register}
                            name="vehicle_type"
                            label="Vehicle Type"
                            selectedPackage={selectedOneWayPackage}
                            handleType={setVehicleType}
                            handleSeat={setSelectedSeat}
                            setValue={setValue}
                            defaultValue={vehicleType}
                          />
                          <Error errorName={errors.vehicle_type} />
                        </div>
                      )}

                      {vehicleType ? (
                        <div className="col-span-4">
                          <LabelArea label={"Vehicle Model (Optional)"} />
                          <SelectVehicleModel
                            register={register}
                            label="Vehicle Model"
                            name="vehicle_modal"
                            required={false}
                            type="text"
                            vehicleType={vehicleType}
                            defaultValue={vehicleModel}
                            onChange={(e) => setVehicleModel(e.target.value)}
                            placeholder={"Vehicle Model"}
                          />
                          <Error errorName={errors.vehicle_modal} />
                        </div>
                      ) : null}

                      {/* Adult Dropdown */}
                      <div className="col-span-4">
                        <LabelArea label={"Adult"} required />
                        <Select
                          {...register("no_of_adult")}
                          value={adultCount}
                          onChange={(e) => setAdultCount(e.target.value)}
                          className="block w-full px-4 py-2 text-sm border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                        >
                          {adultOptions.length > 0 ? (
                            adultOptions.map((num) => (
                              <option key={num} value={num}>
                                {num}
                              </option>
                            ))
                          ) : (
                            <option disabled value="">
                              Choose vehicle type
                            </option>
                          )}
                        </Select>
                        {errors.no_of_adult && (
                          <p className="text-red-500 text-xs">
                            {errors.no_of_adult.message}
                          </p>
                        )}
                      </div>

                      {/* Child Dropdown */}
                      <div className="col-span-4">
                        <LabelArea label={"Child (Optional)"} />
                        <Select
                          {...register("no_of_kids")}
                          value={childCount}
                          defaultValue={myData?.no_of_kids}
                          onChange={(e) => handleChildChange(e.target.value)}
                          className="block w-full px-4 py-2 text-sm border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                        >
                          {childOptions.length > 0 ? (
                            childOptions.map((num) => (
                              <option key={num} value={num}>
                                {num}
                              </option>
                            ))
                          ) : (
                            <option disabled value="">
                              Choose adult first
                            </option>
                          )}
                        </Select>
                      </div>
                    </fieldset>
                    {/* Selling Price stays editable even once the trip has
                                            started — intentionally outside the tripStartedLock
                                            fieldset above. */}
                    {/* Selling Price */}
                    {id ? (
                      <div className="col-span-4">
                        <LabelArea label={"Selling Price"} required />
                        <InputAreaPrice
                          trigger={trigger}
                          register={register}
                          label="Selling Price"
                          name="selling_price"
                          type="text"
                          maxLength={6}
                          required={true}
                          placeholder={"Selling Price"}
                          pattern="^[0-9]*\.?[0-9]+$"
                          disabled={cantEditSellingPrice}
                        />
                        <Error errorName={errors.selling_price} />
                      </div>
                    ) : (
                      <div className="col-span-4">
                        <LabelArea label={"Selling Price"} required />
                        <InputAreaPrice
                          trigger={trigger}
                          register={register}
                          label="Selling Price"
                          name="selling_price"
                          type="text"
                          maxLength={6}
                          required={true}
                          placeholder={"Selling Price"}
                          pattern="^[0-9]*\.?[0-9]+$"
                        />
                        <Error errorName={errors.selling_price} />
                      </div>
                    )}

                    <fieldset disabled={tripStartedLock} className="contents">
                      {/* Booking Date */}
                      <div className="col-span-4">
                        <LabelArea label={"Booking Date"} required />
                        {isOnline ? (
                          <>{formatDate(myData?.booking_date)}</>
                        ) : (
                          <>
                            {selectedTripType !== "Holiday Package" &&
                            selectedTripType !== "Outstation" ? (
                              <InputAreaDate
                                trigger={trigger}
                                register={register}
                                label="Booking Date"
                                name="booking_date"
                                type="date"
                                value={bookingDate}
                                onChange={(event) => setBookingDate(event)}
                                max={new Date()}
                              />
                            ) : (
                              <InputAreaDate
                                trigger={trigger}
                                register={register}
                                label="Booking Date"
                                name="booking_date"
                                type="date"
                                value={bookingDate}
                                onChange={(event) => setBookingDate(event)}
                                // min={new Date()}
                                //max={watch('day_1_start_date')}
                                max={new Date()}
                              />
                            )}
                            <Error errorName={errors.booking_date} />{" "}
                          </>
                        )}
                      </div>
                      {/* {console.log(errors)} */}
                      {/* No. of Days (conditionally rendered based on selectedTripType) */}
                      {selectedTripType === "Holiday Package" ||
                      selectedTripType === "Outstation" ? (
                        <>
                          <div className="col-span-4">
                            <LabelArea label={"No. of Days"} required />
                            <InputArea
                              trigger={trigger}
                              register={register}
                              label="No of Days"
                              name="no_of_days"
                              type="text"
                              maxLength={2}
                              placeholder={"No of Days"}
                              onChange={handleDaysChange}
                              readOnly={tripStartedLock}
                            />
                            <Error errorName={errors.no_of_days} />
                          </div>

                          {!isOnline && (
                            <div className="col-span-4">
                              <LabelArea label={"Is Multi-trip"} required />
                              <RadioButton
                                register={register}
                                name="multitrip"
                                value1={false}
                                value2={true}
                                label1="No"
                                label2="Yes"
                                label="Company Type"
                                selectedValue={selectedMultiValue}
                                handleChange={handleChangeMultiTrip}
                              />
                              <Error errorName={errors.multitrip} />
                            </div>
                          )}
                        </>
                      ) : null}

                      {/* Dynamic Rows */}
                      {selectedTripType === "Holiday Package" ||
                      selectedTripType === "Outstation" ? (
                        <>
                          <div className="flex flex-col gap-4 col-span-12">
                            {Array.from({ length: days }, (_, i) => (
                              <div
                                key={i}
                                className="flex gap-4 items-center mb-2"
                              >
                                {/* Day Label */}
                                <div className="shrink-0 items-center">
                                  <span className="font-medium">
                                    Day {i + 1}
                                  </span>
                                </div>

                                {/* Date Picker */}
                                <div className="relative">
                                  <InputAreaDate
                                    register={register}
                                    label="Start Date"
                                    name={`day_${i + 1}_start_date`}
                                    value={watch(`day_${i + 1}_start_date`)}
                                    onChange={(date) => {
                                      if (i === 0) {
                                        setValue(
                                          `day_${i + 1}_start_date`,
                                          date,
                                        );
                                        //setBookingDate(null);
                                      }
                                    }}
                                    min={minMultiDayStartDate}
                                    readOnly={i !== 0 || tripStartedLock}
                                  />

                                  <Error
                                    errorName={
                                      errors[`day_${i + 1}_start_date`]
                                    }
                                  />
                                </div>

                                {/* Select From */}
                                {/* Start City */}
                                <div className="flex-1 relative">
                                  <BookingSelectSingleCityOnly
                                  cities={cities}
                                  setSingleCity={setSingleCity}
                                    register={register}
                                    label="Start City"
                                    name={`day_${i + 1}_startcity`}
                                    type="text"
                                    placeholder="--Choose--"
                                    selectedCity={
                                      i === 0
                                        ? selectedStartCityName // first day uses selectedStartCityName
                                        : watch(`day_${i}_endcity`) // other days use previous day's end city
                                    }
                                    handleCityChangeName={
                                      (value) =>
                                        setValue(
                                          `day_${i + 1}_startcity`,
                                          value,
                                        ) // store label in form
                                    }
                                    readonly={tripStartedLock || isOnline}
                                  />
                                  <Error
                                    errorName={errors[`day_${i + 1}_startcity`]}
                                  />
                                </div>

                                {/* End City */}
                                <div className="flex-1 relative">
                                  <BookingSelectSingleCityOnly
                                  cities={cities}
                                  setSingleCity={setSingleCity}

                                  
                                    register={register}
                                    label="End City"
                                    name={`day_${i + 1}_endcity`}
                                    type="text"
                                    placeholder="--Choose--"
                                    selectedCity={
                                      i === days - 1
                                        ? selectedEndCityName // last day uses selectedEndCityName
                                        : watch(`day_${i + 1}_endcity`) // other days use current end city
                                    }
                                    handleCityChangeName={(value) => {
                                      setValue(`day_${i + 1}_endcity`, value); // store label in form
                                      // propagate label to next day's start city
                                      if (i + 2 <= days) {
                                        setValue(
                                          `day_${i + 2}_startcity`,
                                          value,
                                        );
                                      }
                                    }}
                                    readonly={tripStartedLock || isOnline}
                                  />
                                  <Error
                                    errorName={errors[`day_${i + 1}_endcity`]}
                                  />
                                </div>
                              </div>
                            ))}
                          </div>
                        </>
                      ) : null}

                      {selectedTripType === "Holiday Package" ||
                      selectedTripType === "Outstation" ? (
                        <div className="col-span-12">
                          <LabelArea label={"Itinerary Details"} required />
                          <QuillEditor
                            required={true}
                            readOnly={isOnline}
                            value={itinerary}
                            onChangeFunction={(newContent) =>
                              setItinerary(newContent)
                            }
                            register={register}
                            label="Itinerary Details"
                            name="itinerary"
                          />
                          <Error errorName={errors.itinerary} />
                        </div>
                      ) : null}
                    </fieldset>

                    {/* Special Note and Vehicle Note stay editable even once
                                            the trip has started — intentionally outside the
                                            tripStartedLock fieldset above. */}
                    <div className="col-span-12">
                      <LabelArea label={"Additional features (Optional)"} />
                      <QuillEditor
                        required={false}
                        readOnly={isOnline}
                        maxLength={200}
                        value={specialNote}
                        onChangeFunction={(newContent) =>
                          setSpecialNote(newContent)
                        }
                        register={register}
                        label="Special note"
                        name="special_note"
                      />
                      <Error errorName={errors.special_note} />
                    </div>

                    <div className="col-span-12">
                      <LabelArea label={"Vehicle note (Optional)"} />

                      <QuillEditor
                        required={false}
                        readOnly={isOnline}
                        value={vehicleNote}
                        onChangeFunction={(newContent) =>
                          setVehicleNote(newContent)
                        }
                        register={register}
                        label="Vehicle note"
                        name="vehicle_note"
                      />
                      <Error errorName={errors.vehicle_note} />
                    </div>
                  </div>
                </>
              ) : null}

              {/* <DrawerCancelNext handleNextStep={handleNextStep} /> */}
              <DrawerButton
                isSubmitting={loading}
                id={id}
                title={id ? "Update" : "Save"}
              />
            </fieldset>
          </div>
        </form>
      </Scrollbars>
    </>
  );
};

export default BookingsDrawerCity;
